import { Platform, Platforms } from "./PlatformCommandInteraction";

export type Control = "Control";
export type Command = "Command";
export type Alt     = "Alt";
export type Option  = "Option";
export type Shift   = "Shift";
export type Meta    = "Meta";
export type Mod1    = "Mod1";
export type Mod2    = "Mod2";

export type ModifierKey = 
  Control | 
  Command |
  Alt     |
  Option  |
  Shift   |
  Meta    |
  Mod1    |
  Mod2  
;

/*
matcher: if ( $1 == key ){ ret}
replace: static readonly $1:$1 = "$2"; 
*/

export class ModifierKeys
{
  static readonly Control:Control = "Control";
  static readonly Command:Command = "Command";
  static readonly Alt:Alt = "Alt";
  static readonly Option:Option = "Option";
  static readonly Shift:Shift = "Shift";
  static readonly Meta:Meta = "Meta";
  static readonly Mod1:Mod1 = "Mod1";
  static readonly Mod2:Mod2 = "Mod2";

  static isModifierKey( key:string )
  {
    if ( ModifierKeys.Control == key ){ return true; }
    if ( ModifierKeys.Command == key ){ return true; }
    if ( ModifierKeys.Alt == key ){ return true; }
    if ( ModifierKeys.Option == key ){ return true; }
    if ( ModifierKeys.Shift == key ){ return true; }
    if ( ModifierKeys.Meta == key ){ return true; }
    if ( ModifierKeys.Mod1 == key ){ return true; }
    if ( ModifierKeys.Mod2 == key ){ return true; }

    return false;
  }

  static getKeyFor( modifierKey:ModifierKey, platform:Platform )
  {
    if ( ModifierKeys.Mod1 == modifierKey )
    {
      return Platforms.Mac == platform ? ModifierKeys.Command : ModifierKeys.Control;
    }

    if ( ModifierKeys.Mod2 == modifierKey )
    {
      return Platforms.Mac == platform ? ModifierKeys.Option : ModifierKeys.Alt;
    }

    return modifierKey;
  }

}